import apiClient from './client'
import { unwrapList } from './responseAdapter'

export interface HerbInfo {
  id?: number
  chinese_name?: string
  category?: string
  subcategory?: string
  latin_name?: string
  pinyin?: string
  scientific_name?: string
  kingdom?: string
  phylum?: string
  class_name?: string
  order_name?: string
  family?: string
  genus?: string
  processed_name?: string
  source?: string
  medicinal_part?: string
  harvest_time?: string
  distribution?: string
  processing_method?: string
  processed_description?: string
  nature_flavor?: string
  meridian?: string
  functions?: string
  indications?: string
  usage_dosage?: string
  precautions?: string
  storage?: string
  is_food_medicine?: string
  function_category_id?: string
}

export interface HerbListResponse {
  herbs: HerbInfo[]
  total: number
}

export interface HerbListParams {
  skip?: number
  limit?: number
  search?: string
  category?: string
}

export async function listHerbs(params: HerbListParams = {}): Promise<HerbListResponse> {
  const response = (await apiClient.get('/v1/herbs/list', { params })) as unknown as HerbListResponse
  if (response && Array.isArray(response.herbs)) {
    return response
  }
  const { rows, total } = unwrapList<HerbInfo>(response)
  return { herbs: rows, total }
}
